export const app = {
  connectToYourWhatsappNumber: 'الاتصال برقم واتس اب الخاص بك',
  connectYourWhatsappBotWithYourWhatsappNumber: 'قم بتوصيل Whatsapp Bot الخاص بك برقم Whatsapp الخاص بك',
  connect: 'توصيل',
};
